import * as Bixby from '$/core';
import { DataSiteEmailTrackingData } from '$/core/models';
import { WmtTaskPriority } from '$/core/enums';

export enum TaskType {
  EmailTask = 'EmailTask',
  MissingEmailTask = 'MissingEmailTask',
}

export interface TaskModalContext {
  taskData: DataSiteEmailTrackingData;
  assigneeList?: Bixby.Models.AssignableUser[];
  onClose: () => void;
  /**
   * Called when the user takes an action on the task.
   *
   * @param assigneeId - New assignee ID, or `null` to leave unassigned.
   * @param dueDate - Due date string (YYYY-MM-DD), or `null` if not set.
   * @param priority - Selected task priority.
   * @param note - Optional note text to include with this action.
   *   When the backend is ready, this will be persisted alongside the task update.
   */
  onTaskCreated: (assigneeId: string | null, dueDate: string | null, priority: WmtTaskPriority, note?: string) => Promise<void>;
}

export interface TaskModalComponentProps extends TaskModalContext {
  isOpen: boolean;
}

export type TaskModalComponent = React.ComponentType<TaskModalComponentProps>;

/**
 * Determines which task type applies to a given row.
 * Add new rules here when new task types are introduced.
 */
export function resolveTaskType(taskData: DataSiteEmailTrackingData): TaskType {
  if (taskData.missingClients && taskData.missingClients.length > 0) {
    return TaskType.MissingEmailTask;
  }
  return TaskType.EmailTask;
}

export function formatLastAssignment(task: Bixby.Models.ClientCompanyTask): string {
  const date = new Date(task.dateAssigned);
  const datePart = date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
  const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  const assignedToPart = task.assignedTo ? ` to ${task.assignedTo}` : '';
  return `Latest task assigned on ${datePart} at ${timePart} (${task.taskType}) by ${task.createdBy}${assignedToPart} for ${task.clientName}`;
}
